import React, { Fragment, h } from "preact";
import {Card} from '../../_common/layout'
import {t} from '../../_i18n'
import AlertBox from "../../_common/components/AlertBox/AlertBox";
import {ButtonGhost} from "../../_common/components/buttons/buttons";
import {formatDateLong} from "../../utils";

export default function EnrollsList({type, enrollsInPeriod, onAction, className}) {
    const title = type === 'pending' ? t('Asignaturas sin aplazar') : t('Asignaturas aplazadas')
    const noEnrollsText = type === 'pending' ? t('no_enrolls_current_period') : t('no_enrolls_next_period')
    const buttonText = type === 'pending' ? t('postpone_enroll') : t('activate_enroll')
    const formativeActionsKey = type === 'pending' ? 'pending_formative_actions' : 'postponed_formative_actions'
    const hasEnrolls = enrollsInPeriod?.academic_programs?.some(ap => ap[formativeActionsKey]?.length > 0)
    const hasMultipleAcademicPrograms = enrollsInPeriod?.academic_programs?.length > 1
    const outOfPeriod = type === 'pending' && new Date().getTime() > enrollsInPeriod?.postponement_end_date.getTime()

    const infoHTML = () => {
        if (!hasEnrolls) {
            return <p>{noEnrollsText}</p>
        }

        if (type === 'pending') {
            if (outOfPeriod) {
                return <p>{t('El periodo para solicitar el aplazamiento ha expirado')}</p>
            }

            if (enrollsInPeriod.postponement_end_date) {
                const dateDetails = formatDateLong(enrollsInPeriod.postponement_end_date)
                const dateString = `${dateDetails[0]} de ${dateDetails[1]} de ${dateDetails[2]}`
                const text = t('postponement_period_end_date').replace('{end_date}', dateString)
                return (
                    <AlertBox type={'info'} className={'m-top'}>
                        <span dangerouslySetInnerHTML={{__html:text}} />
                    </AlertBox>
                )
            }
        }

        if (type === 'postponed') {
            if (enrollsInPeriod.resume_enroll_date) {
                const dateDetails = formatDateLong(enrollsInPeriod.resume_enroll_date)
                const dateString = `${dateDetails[1]} de ${dateDetails[2]}`
                const text = t('resume_enroll_date').replace('{end_date}', dateString)
                return <p>{text}</p>
            }
        }


        // if (type === 'pending' && outOfPeriod) {
        //     return <p>{t('El periodo para solicitar el aplazamiento ha expirado')}</p>
        // } else if (type === 'postponed' && !hasEnrolls) {
        //     return <p>{t('no_enrolls_in_period')}</p>
        // } else if (type === 'pending' && enrollsInPeriod.postponement_end_date) {
        //     const dateDetails = formatDateLong(enrollsInPeriod.postponement_end_date)
        //     const dateString = `${dateDetails[0]} de ${dateDetails[1]} de ${dateDetails[2]}`
        //     const text = t('postponement_period_end_date').replace('{end_date}', dateString)
        //     return (
        //         <AlertBox type={'info'} className={'m-top'}>
        //             <span dangerouslySetInnerHTML={{__html:text}} />
        //         </AlertBox>
        //     )
        // } else if (type === 'postponed' && enrollsInPeriod.resume_enroll_date) {
        //     const dateDetails = formatDateLong(enrollsInPeriod.resume_enroll_date)
        //     const dateString = `${dateDetails[1]} de ${dateDetails[2]}`
        //     const text = t('resume_enroll_date').replace('{end_date}', dateString)
        //     return <p>{text}</p>
        // }
    }

    // if (!hasEnrolls) {
    //     return (
    //         <div className={className}>
    //             <h2>{title}</h2>
    //             <p>{noEnrollsText}</p>
    //         </div>
    //     )
    // }

    return (
        <div>
            <h2 className={className}>{title}</h2>
            { infoHTML() }
            { !outOfPeriod && enrollsInPeriod?.academic_programs?.map(ap =>
                <Fragment>
                    { hasMultipleAcademicPrograms && <h3>{ap.academic_program_title}</h3>}
                    { ap[formativeActionsKey]?.map(e =>
                        <Card className='m-top' smOnly={false}>
                            <div className='d-flex flex-space-between flex-column sm-no-flex-column'>
                                <div className='sm-col-70'>
                                    <div className='t-upper font-color-879CA1 font-14'>{e.formative_action_code}</div>
                                    <div className='font-20 m-top-half'>{e.formative_action_title}</div>
                                </div>
                                <div className='sm-col-30 d-flex flex-center-y m-top sm-no-m-top'>
                                    <ButtonGhost className='t-upper full-width font-14' onClick={() => onAction({...e, resume_enroll_date: enrollsInPeriod.resume_enroll_date})}>
                                        {buttonText}
                                    </ButtonGhost>
                                </div>
                            </div>
                        </Card>)
                    }
                </Fragment>
                )
            }
        </div>
    )
}
